import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CardsSection from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { LiveEventFooter } from 'academy-common-lib/features/liveEvents/components/LiveEventFooter';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { RouterLink } from '../../../components/AcademyLinks.migrated';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { ACADEMY_ONBOARDING_URL_FRAGMENT } from '../../../constants/Navigation.legacy';
import UsageTracker from '../../../utils/UsageTracker';
import { useOnboardingHomeRow } from './useOnboardingHomeRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShowAllLink = () => {
  const trackShowAllClick = () => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'onboarding-home-row-show-all-clicked'
  });
  return /*#__PURE__*/_jsx(RouterLink, {
    marginInlineStart: "200",
    onClick: trackShowAllClick,
    to: ACADEMY_ONBOARDING_URL_FRAGMENT,
    underline: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.academyOnboarding.homeRow.showAll"
    })
  });
};
const renderFooter = cardModel => {
  if (cardModel.type !== 'LIVE_EVENT') {
    return null;
  }
  const liveEvent = cardModel;
  return /*#__PURE__*/_jsx(LiveEventFooter, {
    attended: liveEvent.attended,
    eventType: liveEvent.eventType,
    nextRegisteredSession: liveEvent.nextRegisteredSession,
    nextUpcomingEventSession: liveEvent.nextUpcomingEventSession
  });
};
export const OnboardingHomeRow = () => {
  const {
    isTablet
  } = useMediaQuery();
  const [maxCards, setMaxCards] = useState(4);
  const {
    items,
    headerState,
    loading,
    error,
    hasContent
  } = useOnboardingHomeRow();
  const isContinue = headerState === 'continue';
  const displayedItems = isTablet ? items : items.slice(0, maxCards);
  if (!loading && (error || !hasContent)) {
    return null;
  }
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": loading,
      "data-test-id": "onboarding-home-row",
      children: /*#__PURE__*/_jsx(CardsSection, {
        appearsIn: "academy-onboarding-live-event",
        cardsContainerProps: {
          paddingBlockEnd: '0'
        },
        content: displayedItems,
        description: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: isContinue ? 'learningCenter.academyOnboarding.homeRow.continueSubtitle' : 'learningCenter.academyOnboarding.homeRow.getStartedSubtitle'
          }), isTablet && /*#__PURE__*/_jsx(ShowAllLink, {})]
        }),
        direction: isTablet ? 'column' : 'row',
        flush: true,
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isContinue ? 'learningCenter.academyOnboarding.homeRow.continueTitle' : 'learningCenter.academyOnboarding.homeRow.getStartedTitle'
        }),
        headerActions: !isTablet && /*#__PURE__*/_jsx(ShowAllLink, {}),
        isLoading: loading,
        maxSkeletonListLength: 4,
        navMarker: loading ? undefined : 'HOMEPAGE_ONBOARDING_ROW_LOADED',
        renderFooter: renderFooter,
        setMaxCards: isTablet ? undefined : setMaxCards,
        showOverview: true,
        size: isTablet ? 'small' : 'large'
      })
    })
  });
};